module.exports = __webpack_public_path__ + "static/media/uvamy.628e5c78.png";